import { __assign, __extends } from "tslib";
import * as React from 'react';
import { NotFoundError } from './routeNotFound';
function NotFoundBoundary(props) {
    return React.createElement(InnerNotFoundBoundary, __assign({}, props));
}
var InnerNotFoundBoundary = /** @class */ (function (_super) {
    __extends(InnerNotFoundBoundary, _super);
    function InnerNotFoundBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        return _this;
    }
    InnerNotFoundBoundary.getDerivedStateFromProps = function (props, state) {
        if (state.error && props.request.pathname !== state.errorPathname) {
            return {
                error: undefined,
                errorPathname: undefined,
                errorInfo: undefined,
            };
        }
        return null;
    };
    InnerNotFoundBoundary.prototype.componentDidCatch = function (error, errorInfo) {
        if (error instanceof NotFoundError) {
            this.setState({
                error: error,
                errorInfo: errorInfo,
                errorPathname: this.props.request.pathname,
            });
        }
        else {
            throw error;
        }
    };
    InnerNotFoundBoundary.prototype.render = function () {
        // As SSR doesn't support state, and thus can't recover using error
        // boundaries, we'll also check for a 404 on the response object (as
        // during SSR, the response will always be complete before rendering).
        if (this.state.error || this.props.response.status === 404) {
            return this.props.notFoundRouter(this.props.request, this.props.response);
        }
        return this.props.children;
    };
    return InnerNotFoundBoundary;
}(React.Component));
export var routeNotFoundBoundary = function (initialRouter, notFoundRouter) {
    return function (request, response) { return (React.createElement(NotFoundBoundary, { request: request, response: response, notFoundRouter: notFoundRouter }, initialRouter(request, response))); };
};
